import { PillItem, PillItemGrey } from "../pill"
import { CandidatesTabProps } from "./model"
import { ApplicationCandidateList } from "../applicationCandidateList";

export const CandidatesTab = (props: CandidatesTabProps) => {
    return (
        <div id="available-job-title" className="h-full">
            <div className="flex mt-[16px] sm:mt-[24px] items-center">
                <PillItem
                    text="Candidați curenți"
                    classes={`cursor-pointer current-candidates-tab text-[13px] sm:text-base ${props.isCurrentCandidatesTabActive ? `active-list` : `active-list-white`}`}
                    onClick={() => props.onCurrentCandidatesClicked()}
                />
                <PillItemGrey
                    text="Istoric"
                    classes={`ml-[4px] cursor-pointer current-candidates-tab text-[13px] sm:text-base ${props.isCurrentCandidatesTabActive ? `active-list-white` : `active-list`}`}
                    onClick={() => props.onIstoricCandidateClicked()}
                />
            </div>

            <div className="mt-[16px] sm:mt-[32px] h-full">
                <ApplicationCandidateList url="applications" candidates={props.candidates} loading={props.loading} />
            </div>
        </div>
    )
}